module.exports = __webpack_public_path__ + "img/Regenwald.5b6779ff.jpg";